class QuickAddTrigger extends HTMLElement {
  static get observedAttributes() {
    return ['data-initialized'];
  }

  constructor() {
    super();
    this.state = {
      isLoading: false,
    }
    this.elements = {
      trigger: this.querySelector('[data-quick-add-trigger-el="trigger"]'),
    }
  }

  connectedCallback () {
    this.setEventListeners()
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-initialized' && newValue === 'true') {
      this.setEventListeners();
    }
  }

  setEventListeners () {
    this.elements.trigger.addEventListener('click', this.onClick.bind(this));
    this.elements.trigger.addEventListener('touchstart', this.onClick.bind(this));
  }

  onClick (event) {
    event.preventDefault()

    this.isLoading = true
    this.classList.add('loading')
    document.querySelector('html').style.overflow = 'hidden'

    const customEvent = new CustomEvent('quick-add:load', {
      detail: {
        handle: this.productHandle,
      },
      bubbles: true,
    })
    this.dispatchEvent(customEvent)

    this.isLoading = false
  }

  get productHandle () {
    return this.dataset.productHandle
  }

  set isLoading (value) {
    this.state.isLoading = value

    this.elements.trigger.classList.toggle('loading', value)
  }
}

customElements.define('quick-add-trigger', QuickAddTrigger)
